import Vue from "vue";
import VueRouter from "vue-router";
import landing from "@/views/LandingPage.vue";
import RegisterPlan from "@/views/RegisterPlan.vue";
import PaymentPlan from '@/views/PaymentPlan.vue';



// import Patient

//import PaymentTotemList from "@/views/payment-totem/PaymentTotemList.vue";
//import PaymentTotemDetails from "@/views/payment-totem/PaymentTotemDetails.vue";

const guard = function(to: any, from: any, next: any) {
  const token = localStorage.getItem("token");

  const publicPath = to.matched.find(
    (path) => path.name === "Public" || path.name === "Home"
  );
  if (!token && to.path !== "/landing" && !publicPath) {
    next({
      path: "/landing",
    });
  } else {
    if (to.name == "Home") {
      next();
      return;
    }

    next();
  }
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/layouts/Public.vue"),
    children: [
      {
        path: "/landing",
        name: "landing",
        component: landing,
      },
      {
        path: "/cadastro",
        name: "RegisterPlan",
        component: RegisterPlan,
      },
      {
        path: "/pagamento",
        name: "PaymentPlan",
        component: PaymentPlan,
      },
      {
        path: "/",
        redirect: "/landing",
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/Private.vue"),
    beforeEnter: guard,
    children: [

      // {
      //   path: "/totens/:id",
      //   name: "PaymentTotemDetails",
      //   component: PaymentTotemDetails,
      //   beforeEnter: guard,
      // },
    ],
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
